import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ReseauxInformatiques from "./it-startup/ReseauxInformatiques.vue";
import Programmation from "./it-startup/ProgrammationComponent.vue";
import BannerComponent from "./it-startup/BannerComponent.vue";
import BoxesArea from "./it-startup/BoxesArea.vue";
import { useHead } from "@vueuse/head";

export default /*@__PURE__*/_defineComponent({
  __name: 'ITStartup',
  setup(__props) {

useHead({
  title: 'ACCUEIL - IT+ CODE LAB',
  meta: [
    { name: 'description', content: 'Bienvenue dans le meilleur centre de formation pratique en informatique à Djibouti. | Code Lab | Cours et Formations en informatique à Djibouti' }
    , { name: 'keywords', content: 'formation,Code Lab,formations,angular,vue, html, css,linux,sécurité,javascript, java, informatique,djibouti, Djibouti, programmation, réseaux, cours, codelab, it+' }

  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BannerComponent),
    _createVNode(BoxesArea),
    _createVNode(ReseauxInformatiques),
    _createVNode(Programmation)
  ]))
}
}

})